<template>
	<div>
		<div class="row g-2 justify-content-end mb-3">
			<div class="col-auto">
				<el-button type="info" icon="Plus" plain round @click="dialogCreateVisible = true">Tambah data</el-button>
			</div>
			<div class="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4">
				<el-input v-model="searchKey" placeholder="Cari . . ." prefix-icon="Search" clearable />
			</div>
		</div>
		<el-form :model="formEdit" @submit.prevent="updateUserPresensi" ref="formEdit">
			<el-table :data="userPresensi" row-key="guru_id" table-layout="auto" v-loading="loading">
				<template #empty>
					<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" label="No." :index="indexMethod" />
				<el-table-column label="Nama" prop="nama" />
				<el-table-column label="ID Presensi" prop="user_presensi_id">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="new_user_presensi_id" v-if="rowEditing === row" class="mb-0">
								<el-input type="text" v-model="formEdit.new_user_presensi_id" :placeholder="row.user_presensi_id" clearable style="min-width: 100px" />
							</el-form-item>
							<span v-else :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Status" prop="keaktifan">
					<template #default="{ row }">
						{{ row.keaktifan ? "Aktif" : "Tidak aktif" }}
					</template>
				</el-table-column>
				<el-table-column label="Kontak" prop="kontak">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="aktif" v-if="rowEditing === row" class="mb-0">
								<el-switch v-model="formEdit.terkonfirmasi" inline-prompt active-text="terkonfirmasi" inactive-text="belum konfirmasi" />
							</el-form-item>
							<div class="hstack gap-1 justify-content-between" v-else>
								<span>{{ row.kontak || "-" }}</span>
								<el-tooltip :content="row.terkonfirmasi ? 'Kontak terkonfirmasi' : 'Belum konfirmasi'" placement="right">
									<transition name="fade" mode="out-in">
										<el-icon v-if="row.terkonfirmasi" class="text-bg-success rounded-circle"><CircleCheck /></el-icon>
										<el-icon v-else class="text-warning"><Warning /></el-icon>
									</transition>
								</el-tooltip>
							</div>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Akun WA Penginformasi" prop="session_wa_id">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="session_wa_id" v-if="rowEditing === row" class="mb-0">
								<el-select v-model="formEdit.session_wa_id" filterable :placeholder="row.session_wa_id" clearable style="min-width: 120px">
									<el-option v-for="s in listSesi" :key="s.session_wa_id" :label="`${s.session_wa_id} (${s.nomor})`" :value="s.session_wa_id" />
								</el-select>
							</el-form-item>
							<span v-else :key="row.session_wa_id">{{ row.session_wa_id }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Tindakan">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-space :spacer="spacer" :size="2" v-if="rowEditing === row">
								<el-button type="info" size="small" plain round @click="rowEditing = null">Batal</el-button>
								<el-button type="success" size="small" round native-type="submit" :loading="updating">Simpan</el-button>
							</el-space>
							<el-space :spacer="spacer" :size="2" v-else>
								<el-tooltip content="Edit data">
									<el-button type="primary" size="small" icon="Edit" plain round @click="rowEditing = row" />
								</el-tooltip>
								<el-tooltip content="Hapus data">
									<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
								</el-tooltip>
							</el-space>
						</transition>
					</template>
				</el-table-column>
			</el-table>
		</el-form>
		<el-pagination
			class="flex-wrap justify-content-center mt-3"
			v-model:current-page="currentPage"
			v-model:page-size="pageSize"
			:page-sizes="[5, 10, 25, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalData"
			@change="getUserPresensi" />

		<el-form :model="formCreate" :rules="rulesCreate" ref="formCreate" @submit.prevent="insertUserPresensi" label-width="auto" :disabled="inserting">
			<el-dialog v-model="dialogCreateVisible" title="Tambah Data" align-center :width="modalWidth">
				<el-form-item prop="user_presensi_id" label="ID Presensi">
					<el-input v-model="formCreate.user_presensi_id" placeholder="Masukkan PIN/ID Presensi" />
				</el-form-item>
				<el-form-item prop="session_wa_id" label="WA Penginformasi">
					<el-select v-model="formCreate.session_wa_id" filterable placeholder="Pilih Akun WA Penginformasi">
						<el-option v-for="s in listSesi" :key="s.session_wa_id" :label="`${s.session_wa_id} (${s.nomor})`" :value="s.session_wa_id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="type_id" label="Guru">
					<el-select v-model="formCreate.type_id" filterable placeholder="Pilih Guru">
						<el-option v-for="nu in listNonUser" :key="nu.guru_id" :label="nu.nama" :value="nu.guru_id" />
					</el-select>
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "UserGuru",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			userPresensi: [],
			listNonUser: [],
			dialogCreateVisible: false,
			formCreate: {
				user_presensi_id: null,
				session_wa_id: null,
				type_id: null,
			},
			rulesCreate: {
				user_presensi_id: [{ required: true, message: "Masukkan PIN/ID presensi", trigger: "change" }],
				session_wa_id: [{ required: true, message: "Pilih akun WA penginformasi", trigger: "change" }],
				type_id: [{ required: true, message: "Pilih guru", trigger: "change" }],
			},
			rowEditing: null,
			formEdit: {
				new_user_presensi_id: null,
				session_wa_id: null,
				terkonfirmasi: false,
			},
			inserting: false,
			loading: true,
			updating: false,
			deleting: false,
			searchKey: null,
			debounceSearch: null,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		updateEditing: Function,
		listSesi: Array,
		modalWidth: String,
	},
	computed: {
		formEditChanged() {
			return (
				this.rowEditing !== null &&
				((this.formEdit.new_user_presensi_id !== null &&
					this.formEdit.new_user_presensi_id.trim() !== "" &&
					this.formEdit.new_user_presensi_id !== this.rowEditing.user_presensi_id) ||
					(this.formEdit.session_wa_id !== null && this.formEdit.session_wa_id !== this.rowEditing.session_wa_id) ||
					this.formEdit.terkonfirmasi !== this.rowEditing.terkonfirmasi)
			);
		},
	},
	watch: {
		searchKey() {
			clearTimeout(this.debounceSearch);
			this.loading = true;

			this.debounceSearch = setTimeout(() => {
				if (this.currentPage === 1) this.getUserPresensi();
				else this.currentPage = 1;
			}, 500);
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
		rowEditing(row) {
			this.$refs.formEdit.resetFields();
			if (row) {
				this.formEdit.terkonfirmasi = row.terkonfirmasi;
			}
		},
		formEditChanged(val) {
			this.updateEditing(val);
		},
	},
	mounted() {
		this.$ws.main.on("user:guru:inserted", this.insertedUser);
		this.$ws.main.on("user:guru:updated", this.updatedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.getUserPresensi();
		this.getListNonUser();
	},
	beforeUnmount() {
		this.$ws.main.off("user:guru:inserted");
		this.$ws.main.off("user:guru:updated");
		this.$ws.main.off("user:deleted");
	},
	beforeRouteLeave(to, from, next) {
		if (this.formEditChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		insertedUser(data) {
			const d = JSON.parse(data);

			const oldNonUserIndex = this.listNonUser.findIndex((u) => u.guru_id === d.guru_id);

			if (oldNonUserIndex !== -1) this.listNonUser.splice(oldNonUserIndex, 1);

			if (!this.searchKey || (this.searchKey && (d.user_presensi_id.includes(this.searchKey) || d.nama.toLowerCase().includes(this.searchKey.toLowerCase())))) {
				const temp = [...this.userPresensi];

				temp.push({
					...d,
					terkonfirmasi: d.is_confirmed === 1,
					keaktifan: d.aktif === 1,
				});
				temp.sort((a, b) => {
					return a.nama.localeCompare(b.nama);
				});

				const checkIndex = temp.findIndex((t) => t.guru_id === d.guru_id);
				if (checkIndex === this.pageSize) {
					this.totalData++;
					return;
				}
				if (checkIndex === 0) {
					this.getUserPresensi();
					return;
				}

				this.userPresensi.splice(checkIndex, 0, {
					...d,
					terkonfirmasi: d.is_confirmed === 1,
					keaktifan: d.aktif === 1,
				});
				if (this.userPresensi.length > this.pageSize) this.userPresensi.pop();

				this.totalData++;
			}
		},
		updatedUser(data) {
			const d = JSON.parse(data);

			if (this.rowEditing && this.rowEditing.guru_id === d.guru_id) this.rowEditing = null;
			this.userPresensi.every((up) => {
				if (up.guru_id === d.guru_id) {
					up.user_presensi_id = d.user_presensi_id;
					up.session_wa_id = d.session_wa_id;
					up.is_confirmed = d.is_confirmed;
					up.terkonfirmasi = d.is_confirmed === 1;

					return false;
				}
				return true;
			});
		},
		deletedUser(data) {
			const d = JSON.parse(data);
			if (d.type !== "guru") return;

			this.listNonUser.push({ guru_id: d.type_id, nama: d.nama });

			const totalPages = Math.ceil(this.totalData / this.pageSize);
			const oldUserIndex = this.userPresensi.findIndex((up) => up.user_presensi_id === d.user_presensi_id);

			if (oldUserIndex !== -1) {
				if (this.rowEditing && this.rowEditing.user_presensi_id === d.user_presensi_id) this.rowEditing = null;

				if (this.currentPage === totalPages) {
					this.userPresensi.splice(oldUserIndex, 1);
					this.totalData--;
				} else {
					this.getUserPresensi();
				}
			} else {
				if (this.searchKey === null || (this.searchKey && (d.user_presensi_id.includes(this.searchKey) || d.nama.toLowerCase().includes(this.searchKey.toLowerCase())))) {
					const temp = [...this.userPresensi];

					temp.push(d);
					temp.sort((a, b) => {
						return a.nama.localeCompare(b.nama);
					});

					const checkIndex = temp.findIndex((t) => t.guru_id === d.guru_id);
					if (checkIndex === this.pageSize) {
						this.totalData--;
						return;
					}
					if (checkIndex === 0 && this.currentPage === totalPages) {
						this.userPresensi.shift();
						this.totalData--;
						return;
					}

					this.getUserPresensi();
				}
			}
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, ["Anda yakin ingin menghapus ID presensi ", h("mark", { class: "fw-bold" }, row.nama), "?"]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteUserPresensi(row))
				.catch(() => {});
		},
		async getUserPresensi() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/user", {
					user_presensi_type: "guru",
					key: this.searchKey,
					limit: this.pageSize,
					offset: (this.currentPage - 1) * this.pageSize,
				});

				const result = data.user_presensi;
				result.forEach((r) => {
					r.terkonfirmasi = r.is_confirmed === 1;
					r.keaktifan = r.aktif === 1;
				});

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.userPresensi = result;
				this.totalData = data.count;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getListNonUser() {
			try {
				const { data } = await this.$defaultApi.post("/user/list/non-user", {
					user_presensi_type: "guru",
				});

				this.listNonUser = data.list_non_user;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async insertUserPresensi() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/user/create", {
					...this.formCreate,
					type: "guru",
				});

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateUserPresensi() {
			this.updating = true;
			try {
				if (!this.formEditChanged) {
					throw Error("Anda belum melakukan perubahan");
				}

				const { data } = await this.$defaultApi.post("/user/update", {
					old_user_presensi_id: this.rowEditing.user_presensi_id,
					new_user_presensi_id: this.formEdit.new_user_presensi_id,
					session_wa_id: this.formEdit.session_wa_id,
					user_presensi_type: "guru",
					type_id: this.rowEditing.guru_id,
					is_confirmed: this.formEdit.terkonfirmasi === this.rowEditing.terkonfirmasi ? null : this.formEdit.terkonfirmasi ? 1 : 0,
				});

				this.rowEditing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		async deleteUserPresensi(row) {
			this.deleting = true;
			try {
				const { data } = await this.$defaultApi.post("/user/delete", {
					user_presensi_id: row.user_presensi_id,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
